/**
 * Shared types and constants for wallets navigation and filtering
 *
 * These types and constants are used by both route builders (@anchorage/frontoffice)
 * and navigation hooks (@features/vaults) to ensure type consistency.
 */

/**
 * Sort field options for wallets table
 *
 * User-friendly names used in URL parameters and UI.
 * Maps to internal column IDs: 'name' → 'wallet', 'network' → 'networkInfo', 'created' → 'createdAt'
 */
export type WalletsSortBy = 'name' | 'network' | 'created';

/**
 * Sort direction options
 *
 * Standard ascending/descending sort order.
 */
export type WalletsSortDir = 'asc' | 'desc';

/**
 * URL parameter names for wallets filtering
 *
 * Centralized constants to ensure consistency between:
 * - URL building (route builders)
 * - URL parsing (nuqs context)
 *
 * These are the single source of truth for wallet filter parameter names.
 * If you need to rename a parameter, change it here and all usage will stay in sync.
 */
export const WALLETS_URL_PARAMS = {
  ASSETS: 'assets',
  NETWORKS: 'networks',
  SEARCH: 'search',
  SORT_BY: 'sortBy',
  SORT_DIR: 'sortDir',
} as const;
